'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal, Popover } from '@common/components';
import { useToast } from '@common/hooks';
import { SvgKebab } from '@common/icon';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { AuthMutation, UnauthQueryKey } from '@/api';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import type { FestivalReview } from '../../_utils/festivalFetchers';
import { FestivalReviewWriteForm } from './FestivalReviewWriteForm';
interface FestivalReviewMenuProps {
  tourId: string;
  reviewId: string;
  review: FestivalReview;
}
export const FestivalReviewMenu = t0 => {
  const $ = _c(36);
  const {
    tourId,
    reviewId,
    review
  } = t0;
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = AuthMutation["delete:/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}"]();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== queryClient || $[2] !== toast || $[3] !== tourId) {
    t2 = async () => {
      await Promise.all([queryClient.invalidateQueries({
        queryKey: UnauthQueryKey["get:/wello/v1/allows/tour/festival/{tourId}/review"]({
          path: {
            tourId
          }
        })
      }), queryClient.invalidateQueries({
        queryKey: UnauthQueryKey["get:/wello/v1/allows/tour/festival/{tourId}"]({
          path: {
            tourId
          }
        })
      })]);
      toast({
        message: "\uD6C4\uAE30\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC5B4\uC694."
      });
      setIsDeleteModalOpen(false);
    };
    $[1] = queryClient;
    $[2] = toast;
    $[3] = tourId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== toastError) {
    t3 = error => toastError({
      error
    });
    $[5] = toastError;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = {
      ...t1,
      onSuccess: t2,
      onError: t3
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    mutate: deleteReview,
    isPending: isDeleting
  } = useMutation(t4);
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Popover.Trigger className="flex size-26 items-center justify-center"><SvgKebab className="size-14 text-Gray-700" /></Popover.Trigger>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== review || $[12] !== tourId) {
    t6 = <button className="w-118 px-16 py-8 text-left transition-colors duration-150 hover:bg-Gray-25" onClick={() => {
      setIsPopoverOpen(false);
      openResponsiveDialog({
        component: FestivalReviewWriteForm,
        modalHeader: "\uD6C4\uAE30 \uC218\uC815\uD558\uAE30",
        title: "\uD6C4\uAE30 \uC218\uC815\uD558\uAE30",
        drawerType: "full",
        props: {
          tourId,
          review
        }
      });
    }}>수정</button>;
    $[11] = review;
    $[12] = tourId;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <button className="w-118 px-16 py-8 text-left text-R-500 transition-colors duration-150 hover:bg-Gray-25" onClick={() => {
      setIsPopoverOpen(false);
      setIsDeleteModalOpen(true);
    }}>삭제</button>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6) {
    t8 = <Popover.Content className="flex flex-col px-0 py-12 font-400 text-Gray-900 typo-body3">{t6}{t7}</Popover.Content>;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isPopoverOpen || $[18] !== t8) {
    t9 = <Popover.Root open={isPopoverOpen} onOpenChange={setIsPopoverOpen} floatingPadding={8} placement="bottom-end">{t5}{t8}</Popover.Root>;
    $[17] = isPopoverOpen;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsDeleteModalOpen(false);
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex flex-col gap-8"><p className="font-700 text-Gray-900 typo-body2">후기 삭제</p><p className="font-400 text-Gray-700 typo-body3">삭제한 후기는 복구할 수 없어요.</p></div>;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Button className="flex-1" dimensions="H48" theme="sub-fill" onClick={() => setIsDeleteModalOpen(false)}>취소</Button>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== deleteReview || $[24] !== reviewId || $[25] !== tourId) {
    t13 = () => deleteReview({
      path: {
        tourId,
        reviewId
      }
    });
    $[23] = deleteReview;
    $[24] = reviewId;
    $[25] = tourId;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isDeleting || $[28] !== t13) {
    t14 = <div className="flex flex-col gap-24">{t11}<div className="flex items-center gap-8">{t12}<Button className="flex-1" dimensions="H48" loading={isDeleting} theme="primary-fill" onClick={t13}>삭제</Button></div></div>;
    $[27] = isDeleting;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isDeleteModalOpen || $[31] !== t14) {
    t15 = <Modal opened={isDeleteModalOpen} onClose={t10}>{t14}</Modal>;
    $[30] = isDeleteModalOpen;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15 || $[34] !== t9) {
    t16 = <>{t9}{t15}</>;
    $[33] = t15;
    $[34] = t9;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};